(function(){
  // Innebygde automater (16 lokasjoner som finnes som sider). Brukes når
  // kolleksjonen 'lokasjoner' ikke har produkter med koordinater ennå.
  var LOCATIONS=[
    {name:'Kilden Kjøpesenter',city:'Stavanger',lat:58.9179,lng:5.7442,url:'/pages/kilden-kjopesenter-stavanger'},
    {name:'Maxi',city:'Sandnes',lat:58.8542,lng:5.7649,url:'/pages/maxi-sandnes'},
    {name:'Markedet',city:'Haugesund',lat:59.4106,lng:5.2683,url:'/pages/markeded-haugesund'},
    {name:'Laksevåg Senter',city:'Bergen',lat:60.3826,lng:5.2903,url:'/pages/bergen-laksevag-senter'},
    {name:'Oasen Senter',city:'Fyllingsdalen, Bergen',lat:60.3490,lng:5.2905,url:'/pages/oasen-senter-fyllingsdalen-bergen'},
    {name:'Down Town',city:'Porsgrunn',lat:59.1405,lng:9.6558,url:'/pages/down-town-porsgrunn'},
    {name:'CC Drammen',city:'Drammen',lat:59.7440,lng:10.2045,url:'/pages/cc-drammen'},
    {name:'Torget Vest',city:'Drammen',lat:59.7430,lng:10.2010,url:'/pages/torgetvest-drammen'},
    {name:'Liertoppen Senter',city:'Lier',lat:59.7840,lng:10.2580,url:'/pages/liertoppen-senter'},
    {name:'Sjøsiden',city:'Horten',lat:59.4170,lng:10.4830,url:'/pages/sjosiden-horten'},
    {name:'Stortorvet',city:'Kongsberg',lat:59.6650,lng:9.6500,url:'/pages/stortorvet-kongsberg'},
    {name:'Rykkinn',city:'Bærum',lat:59.9330,lng:10.4800,url:'/pages/rykkinn-baerum'},
    {name:'Bryn Senter',city:'Oslo',lat:59.9120,lng:10.8220,url:'/pages/bryn-senter-oslo'},
    {name:'Grorud Senter',city:'Oslo',lat:59.9610,lng:10.8800,url:'/pages/grorud-senter-oslo'},
    {name:'Linderud Senter',city:'Oslo',lat:59.9490,lng:10.8340,url:'/pages/linderud-senter'},
    {name:'Stovner Senter',city:'Oslo',lat:59.9620,lng:10.9250,url:'/pages/stovner-senter'}
  ];

  function boot(){
    if(!window.L){ setTimeout(boot,120); return; }
    var mapEl=document.getElementById('lxMap'); if(!mapEl) return;
    var listEl=document.getElementById('lxList');
    var cards=[].slice.call(document.querySelectorAll('.lx-card'));
    var withCoord=cards.filter(function(c){ return c.getAttribute('data-lat') && c.getAttribute('data-lng'); });

    // Fallback: bygg kort fra innebygd datasett når kolleksjonen er tom for koordinater
    if(withCoord.length===0 && listEl){
      var html='';
      LOCATIONS.forEach(function(l){
        html+='<a href="'+l.url+'" class="lx-card" data-lat="'+l.lat+'" data-lng="'+l.lng+'" data-name="'+l.name+'" data-city="'+l.city+'" data-addr="" data-maps="" data-url="'+l.url+'">'+
          '<div class="lx-card__pin"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z"/><circle cx="12" cy="9" r="2.5" fill="currentColor" stroke="none"/></svg></div>'+
          '<div class="lx-card__b"><p class="lx-card__name">'+l.name+'</p><p class="lx-card__meta">'+l.city+'</p></div>'+
          '<svg class="lx-card__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 6 15 12 9 18"/></svg></a>';
      });
      listEl.innerHTML=html;
      cards=[].slice.call(document.querySelectorAll('.lx-card'));
      withCoord=cards.slice();
    }

    var NORWAY=[62.5,9.5];
    var map=L.map('lxMap',{scrollWheelZoom:false,zoomControl:true}).setView(NORWAY,5);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',{
      subdomains:'abcd', maxZoom:19,
      attribution:'&copy; OpenStreetMap &copy; CARTO'
    }).addTo(map);
    map.on('click',function(){ map.scrollWheelZoom.enable(); });

    function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];}); }
    var markers={}, bounds=[];

    withCoord.forEach(function(c,idx){
      var lat=parseFloat(c.getAttribute('data-lat')), lng=parseFloat(c.getAttribute('data-lng'));
      if(isNaN(lat)||isNaN(lng)) return;
      var icon=L.divIcon({className:'', html:'<div class="lx-marker"><i></i></div>', iconSize:[30,30], iconAnchor:[15,15]});
      var m=L.marker([lat,lng],{icon:icon}).addTo(map);
      var name=c.getAttribute('data-name'), city=c.getAttribute('data-city'), addr=c.getAttribute('data-addr');
      var maps=c.getAttribute('data-maps'), url=c.getAttribute('data-url');
      var pop='<b>'+esc(name)+'</b>';
      if(city||addr) pop+='<span class="lp-addr">'+esc([city,addr].filter(Boolean).join(' · '))+'</span>';
      pop+='<br><a href="'+esc(url)+'">Se lokasjon →</a>';
      if(maps) pop+=' <a href="'+esc(maps)+'" target="_blank" rel="noopener">Veibeskrivelse</a>';
      m.bindPopup(pop);
      markers[idx]=m; bounds.push([lat,lng]);
      c.setAttribute('data-idx',idx);
      c.addEventListener('click',function(ev){
        ev.preventDefault();
        cards.forEach(function(x){x.classList.remove('is-active');}); c.classList.add('is-active');
        map.flyTo([lat,lng],13,{duration:.8}); m.openPopup();
      });
    });

    if(bounds.length>1){ map.fitBounds(bounds,{padding:[45,45],maxZoom:11}); }
    else if(bounds.length===1){ map.setView(bounds[0],11); }
    else { var em=document.getElementById('lxEmpty'); if(em) em.style.display='flex'; }

    var search=document.getElementById('lxSearch');
    if(search){ search.addEventListener('input',function(){
      var q=search.value.trim().toLowerCase();
      cards.forEach(function(c){
        var hay=(c.getAttribute('data-name')+' '+c.getAttribute('data-city')+' '+c.getAttribute('data-addr')).toLowerCase();
        c.style.display = (!q || hay.indexOf(q)>=0) ? '' : 'none';
      });
    }); }

    var nearBtn=document.getElementById('lxNear');
    if(nearBtn){ nearBtn.addEventListener('click',function(){
      if(!navigator.geolocation || !bounds.length) return;
      nearBtn.textContent='Finner deg…';
      navigator.geolocation.getCurrentPosition(function(pos){
        var la=pos.coords.latitude, lo=pos.coords.longitude, best=-1, bd=1e9;
        Object.keys(markers).forEach(function(k){
          var ll=markers[k].getLatLng(), d=Math.pow(ll.lat-la,2)+Math.pow(ll.lng-lo,2);
          if(d<bd){ bd=d; best=k; }
        });
        L.circleMarker([la,lo],{radius:7,color:'#60a5fa',fillColor:'#60a5fa',fillOpacity:.9,weight:2}).addTo(map).bindPopup('Du er her');
        if(best>=0){ var ll=markers[best].getLatLng(); map.flyTo([ll.lat,ll.lng],12,{duration:1}); markers[best].openPopup();
          var card=document.querySelector('.lx-card[data-idx="'+best+'"]'); if(card){ cards.forEach(function(x){x.classList.remove('is-active');}); card.classList.add('is-active'); card.scrollIntoView({block:'nearest'}); } }
        nearBtn.textContent='Finn nærmeste';
      },function(){ nearBtn.textContent='Fant ikke posisjon'; setTimeout(function(){ nearBtn.textContent='Finn nærmeste'; },1800); });
    }); }

    setTimeout(function(){ map.invalidateSize(); },250);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
